import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import SignalIcon from '@/public/images/dashboard/signal.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function PortalsNotificationsEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={SignalIcon}
      title={Trans(translations, 'HereYouWillSeeErrorsAndAlerts')}
      description={Trans(
        translations,
        'RememberToKeepYourPropertiesCompleteAsPossible'
      )}
    />
  );
}

export default PortalsNotificationsEmptyState;
